import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Source from './icon-sparkle.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'sparkle';

export const SparkleIcon = svgIconWrapper(SvgComponent);
